import { useState } from 'react';
import { ArrowUpRight, X } from 'lucide-react';

import { allProjectsPl, allProjectsEn, content } from '../../data';

import './Archive.css';

const Archive = ({ setView, lang }) => {
  const t = content[lang].archive;

  const allProjects = lang === 'en' ? allProjectsEn : allProjectsPl;

  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section className="archive-section">
      <div className="archive-header">
        <div>
          <h1 className="archive-title">{t.title}</h1>
          <p className="archive-subtitle">{t.subtitle}</p>
        </div>
        <button onClick={() => setView('home')} className="back-button">
          {t.back}
        </button>
      </div>
      
      <div className="archive-grid">
        {allProjects.map((project) => (
          <div 
            key={project.id} 
            className="archive-item"
            onClick={() => setSelectedImage(project)}
          >
             <div className="archive-img-wrapper">
               <div className="img-placeholder" />
               <img 
                  src={project.image} 
                  alt={project.title}
               />
             </div>
             <div className="archive-item-info">
               <div>
                  <h3>{project.title}</h3>
                  <span className="archive-year">{project.year}</span>
               </div>
               <span className="archive-category">
                 {project.category} <ArrowUpRight size={14} />
               </span>
             </div>
          </div>
        ))}
      </div>
      
      {selectedImage && (
        <div 
          className="fullscreen-overlay"
          onClick={() => setSelectedImage(null)}
        >
          <button 
            onClick={() => setSelectedImage(null)}
            className="close-button"
          >
            <X size={42} />
          </button>

          <button 
            onClick={(e) => { e.stopPropagation(); }} className="check-button">
            {selectedImage.link ? (
              <a 
                href={selectedImage.link} 
                target="_blank" 
                rel="noopener noreferrer"
              >
                {t.check} <ArrowUpRight size={18} />
              </a>
            ) : (
              <span style={{display: 'none'}}></span>
            )}
          </button>

          <img 
            src={selectedImage.image} 
            alt="Full Screen View" 
            className="fullscreen-img"
            onClick={(e) => {
              e.stopPropagation();
            }}
          />
          
          <div className="fullscreen-title"
            onClick={() => setSelectedImage(null)}>
            <span>{selectedImage.title}</span>
          </div>
        </div>
      )}

      <div className="mobile-close-fab">
        <button onClick={() => setView('home')}>
          {t.close}
        </button>
      </div>
    </section>
  );
};

export default Archive;